import http from "./httpService";
const apiURL = "https://smart.ahlamkom.net";
const apiGetKeywords = apiURL + "/api/dream_keywordsM";
const apiGetKeywordsMeaning = apiURL + "/api/dream_keywords_meaningK";
const apiPOSTKeywordsMeaningBulk = apiURL + "/api/dream_keywords_meaningBulkInsert";
const apiPOSTKeywordsMeaning = apiURL + "/api/dream_keywords_meaning";
const apiPOSTKeywords = apiURL + "/api/dream_keywordsU";



export function geKeywords() {
  const data = localStorage.getItem("token");

  console.log(data);
  //console.log(apiEndpointGetCashU_MT_locked+username +'/'+mob+'/'+islock);
  return http.get(apiGetKeywords, { headers: { Authorization: `Bearer ${data}` } });
}




export function getKeywordsMeaning(keywordsID) {
  const data = localStorage.getItem("token");

  //console.log(apiEndpointGetCashU_MT_locked+username +'/'+mob+'/'+islock);
  return http.get(apiGetKeywordsMeaning + '/' + keywordsID, { headers: { Authorization: `Bearer ${data}` } });
}



export function saveKeywordsMeaning(KeywordsMeaning) {
  /*   if (Dream._id) {
    const body = { ...Dream };
    delete body._id;
    return http.put(DreamUrl(Dream._id), body);
  } */
  const data = localStorage.getItem("token");

  return http.post(apiPOSTKeywordsMeaning, KeywordsMeaning, { headers: { Authorization: `Bearer ${data}` } });
}

export function saveKeywordsMeaningBulk(KeywordsMeaning) {
  /*   if (Dream._id) {
    const body = { ...Dream };
    delete body._id;
    return http.put(DreamUrl(Dream._id), body);
  } */
  const data = localStorage.getItem("token");
  return http.post(apiPOSTKeywordsMeaningBulk, KeywordsMeaning, { headers: { Authorization: `Bearer ${data}` } });
}

export function saveKeywords(Keywords) {
  /*   if (Dream._id) {
    const body = { ...Dream };
    delete body._id;
    return http.put(DreamUrl(Dream._id), body);
  } */
  const data = localStorage.getItem("token");
  return http.post(apiPOSTKeywords, Keywords, { headers: { Authorization: `Bearer ${data}` } });
}





// WEBPACK FOOTER //
// ./src/services/keywordsService.js